<template>
    <div>

      <CToaster :autohide="4000">
        <template v-for="obj in toasts">
          <CToast
              color="success"
              :key="'toast' + obj"
              :show="true"
              @update:show="onDone"
          >
            ทำการบันทึกเรียบร้อย
          </CToast>
        </template>
      </CToaster>

    </div>
</template>

<script>

    import {mapGetters} from 'vuex'

    export default {
        name: 'CenterToaster',
        data: function () {
            return {

            }
        },
        mounted() {

        },

        created() {
        },

        beforeDestroy() {

        },

        methods: {
          onDone(){
            this.$store.commit("dialog/toasts",0)
          }
        },

        computed: {
            ...mapGetters({
              toasts: 'dialog/toasts'
            })
        },

        watch: {
        }
    }
</script>
